import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'deliver-training-files',
  templateUrl: './deliver-training-files.component.html',
  styleUrls: ['./deliver-training-files.component.scss']
})
export class DeliverTrainingFilesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
